import { AdType } from '@/modules/adv/types'

import type { HbBidderConfig } from '../types'

const IN_GAME_BANNER_SITE_ID = '1379783'
const DEFAULT_SITE_ID = '1379543'

const SITE_IDS: Partial<Record<AdType, string>> = {
    leaderboard: '1379784',
    sidebar: '1379785',
    sidebar_bottom: '1379786',
    sticky_desktop: '1379787',
    sticky_mobile: '1379788',
    rewarded: '1379782',
    interstitial_preroll: '1379780',
    interstitial: '1379781',
}

const getSiteId = (type: string) => {
    if (type.startsWith('universal_banner')) {
        return IN_GAME_BANNER_SITE_ID
    }

    return SITE_IDS[type as AdType] ?? DEFAULT_SITE_ID
}

export const INDEX_EXCHANGE: HbBidderConfig = {
    bidder: 'ix',
    params: ({ type }) => ({ siteId: getSiteId(type) }),
}
